// ©2024 Austin App House. All rights reserved.
const isCanadaCountry = (country) => country?.value === 'CA' || country?.label === 'Canada';

const handlerValidateZipCode = (value, country) => {
  if (value) {
    const isCanada = isCanadaCountry(country);
    const pattern = isCanada
      ? /^([A-CEGHJ-NPRSTVXY]\d[A-CEGHJ-NPRSTV-Z][ -]?\d[A-CEGHJ-NPRSTV-Z]\d)$/i
      : /^\d{5}$/;
    if (!pattern.test(value)) {
      return isCanada ? 'Enter valid postal code' : 'Zip code must be 5 numeric digits';
    }
  }
  return undefined;
};

export default handlerValidateZipCode;
